import { render, staticRenderFns } from "./floating-bar.vue?vue&type=template&id=388a5635&scoped=true"
import script from "./floating-bar.vue?vue&type=script&lang=js"
export * from "./floating-bar.vue?vue&type=script&lang=js"
import style0 from "./floating-bar.vue?vue&type=style&index=0&id=388a5635&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388a5635",
  null
  
)

export default component.exports